import { GeneralPropsType } from "@/common/types";
import styles from "./index.module.css";
import clsx from "clsx";
import LottieAnimation from "../LottieAnimation";
import getAnimation from "@/common/function/getAnimation";
export interface LoadingInsidePropsType extends GeneralPropsType {}
function LoadingInside({
  children,
  className
}: LoadingInsidePropsType) {
  return <div className={clsx(className, styles.container, {})} data-sentry-component="LoadingInside" data-sentry-source-file="index.tsx">
            <LottieAnimation className="size-24" src={getAnimation("loading_circle_dots")} data-sentry-element="LottieAnimation" data-sentry-source-file="index.tsx" />
        </div>;
}
export default LoadingInside;